import Cookies from 'js-cookie'

const TokenKey = 'vue_home_teacher_token'
const manageSchoolKey = 'vue_home_teacher_manage_school'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function getTeacherToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getManageSchoolId() {
  return Cookies.get(manageSchoolKey)
}

export function setManageSchoolId(schoolId) {
  return Cookies.set(manageSchoolKey, schoolId)
}

export function removeManageSchoolId() {
  return Cookies.remove(manageSchoolKey)
}

export function getSecondDomain() {
  var domain = window.location.host
  var h = domain.split('.')[0]
  return h
}



// WEBPACK FOOTER //
// ./src/utils/authTeacher.js